// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import Calls from './Calls';
import UserManagement from './UserManagement';
import ServerManagement from './ServerManagement';
import ExtensionMonitor from './ExtensionMonitor';
import QueueReport from './QueueReport';
import LiveQueue from './LiveQueue';
import AccessLogs from './AccessLogs';
import ScheduledReports from './ScheduledReports';
import Layout from './Layout';
import axios from 'axios';
import API_URL from './config';
import './App.css';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [userRole, setUserRole] = useState(null);
  const [username, setUsername] = useState(null);
  const [loadingUserInfo, setLoadingUserInfo] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  const handleLogout = () => {
    setToken(null);
    setUserRole(null);
    setUsername(null);
    localStorage.removeItem('token');
  };

  // Aplica o tema no <html> e persiste a preferência.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((t) => (t === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (token) {
        setLoadingUserInfo(true);
        try {
          const response = await axios.get(`${API_URL}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUserRole(response.data.role);
          setUsername(response.data.username);
        } catch (error) {
          console.error('Falha ao buscar informações do usuário:', error);
          handleLogout();
        } finally {
          setLoadingUserInfo(false);
        }
      }
    };
    fetchUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!token) {
    return (
      <Login
        setToken={(newToken) => {
          setToken(newToken);
          localStorage.setItem('token', newToken);
        }}
        theme={theme}
        onToggleTheme={toggleTheme}
      />
    );
  }

  if (loadingUserInfo || userRole === null) {
    return (
      <div className="loadingContainer">
        Carregando informações do usuário...
      </div>
    );
  }

  const isAdmin = userRole === 'admin';
  const isOperador = userRole === 'operador';

  return (
    <BrowserRouter>
      <Layout onLogout={handleLogout} userRole={userRole} username={username} theme={theme} onToggleTheme={toggleTheme}>
        <Routes>
          <Route
            path="/"
            element={
              isOperador
                ? <Navigate to="/monitor-ramais" replace />
                : <Dashboard username={username} userRole={userRole} />
            }
          />
          <Route
            path="/gravacoes"
            element={
              isOperador
                ? <Navigate to="/monitor-ramais" replace />
                : <Calls token={token} userRole={userRole} username={username} />
            }
          />
          <Route path="/monitor-ramais" element={<ExtensionMonitor token={token} userRole={userRole} />} />
          <Route
            path="/relatorio-filas"
            element={
              isOperador
                ? <Navigate to="/monitor-ramais" replace />
                : <QueueReport token={token} userRole={userRole} username={username} />
            }
          />
          <Route path="/monitor-filas" element={<LiveQueue token={token} userRole={userRole} />} />
          <Route
            path="/relatorios"
            element={
              isOperador
                ? <Navigate to="/monitor-ramais" replace />
                : (
                  <div className="reportsPageContainer">
                    <h2>Página de Relatórios</h2>
                    <p>Funcionalidade em desenvolvimento...</p>
                  </div>
                )
            }
          />
          <Route path="/users" element={isAdmin ? <UserManagement token={token} /> : <Navigate to="/" replace />} />
          <Route path="/servers" element={isAdmin ? <ServerManagement token={token} /> : <Navigate to="/" replace />} />
          <Route path="/logs" element={isAdmin ? <AccessLogs token={token} /> : <Navigate to="/" replace />} />
          <Route path="/agendamentos" element={isAdmin ? <ScheduledReports token={token} /> : <Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to={isOperador ? '/monitor-ramais' : '/'} replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
